<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage goods received</small>
      </legend>
      <div></div>
      <div>
        <div class="goodsreceivingLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color:blue"></i>loading goodsreceiving...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemGoodsreceiving"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'Action'">
              <button
                type="submit"
                class="btn btn-primary btn-sm btn-rounded goodreceiving_id"
                @click="viewGrn(props.row.id)"
              >
                <i class="fa fa-plus"></i>
                print Grn
              </button>
            </span>
            <span v-else-if="props.column.field === 'Paid'">
              <span v-if="props.row.paid_status === 0">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm btn-rounded"
                  @click="getGoodsnote(props.row.id)"
                >
                  <i class="fa fa-plus"></i> Pay
                </button>
              </span>
              <span v-else-if="props.row.paid_status === 1">
                <button class="btn btn-success btn-sm btn-rounded">
                  <i class="fa fa-check"></i> Paid
                </button>
              </span>
            </span>

            <span v-else-if="props.column.field === 'Edit'">
              <button
                type="submit"
                class="btn btn-primary btn-sm btn-rounded"
                @click="editNote(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Goodsreceiving no",
          field: "receiving_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter grn number"
          }
        },
        {
          label: "Received date",
          field: "receiving_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" // outputs Mar 16th 2018
        },
        {
          label: "Payable amount",
          field: "goods_grand_total",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "100px",
          html: true
        },
        {
          label: "Received",
          field: "Paid",
          width: "100px",
          html: true
        },
        {
          label: "Edit",
          field: "Edit",
          width: "100px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadGoodsreceiving();
  },

  computed: {
    ...mapGetters(["systemGoodsreceiving"])
  },

  methods: {
    ...mapActions(["loadGoodsreceiving", "viewGrn", "getGoodsnote", "editNote"])
  }
};
</script>


// WEBPACK FOOTER //
// src/goodsreceiving/managegoodsreceiving.vue